import { render, staticRenderFns } from "./ProdutoListModal.vue?vue&type=template&id=0f681454&scoped=true"
import script from "./ProdutoListModal.vue?vue&type=script&lang=js"
export * from "./ProdutoListModal.vue?vue&type=script&lang=js"
import style0 from "./ProdutoListModal.vue?vue&type=style&index=0&id=0f681454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f681454",
  null
  
)

export default component.exports